import { Card, Row, Col } from 'react-bootstrap'
import EditCard from './EditCard'
import DeleteCard from './DeleteCard'
import { useSelector } from 'react-redux'
import { useState } from 'react'

export default function EventsCard({ event, getEvents }) {
  const { user: authUser } = useSelector(x => x.auth)
  const [isEditing, setIsEditing] = useState(false)
  const isWebmaster = Boolean(authUser?.user?.isWebmaster)
  const canEdit = isWebmaster

  return (
    <Col xs={12} md={12} lg={12}>
      {canEdit && isEditing ? (
        <>
          <EditCard
            event={event}
            getEvents={getEvents}
            showEditButton={false}
            onCancel={() => setIsEditing(false)}
            onSave={() => setIsEditing(false)}
          />
          {isWebmaster && (
            <DeleteCard
              event={event}
              getEvents={getEvents}
              showDeleteButton={true}
              onDelete={() => setIsEditing(false)}
              onCancel={() => setIsEditing(false)}
            />
          )}
        </>
      ) : (
        <Card className="events-admin-card poll-static-card" id={`${event._id}-card`}>
          <Card.Header className="events-admin-card-header">
            <div className='events-admin-card-headline'>
              <h3 className='events-admin-card-title mb-0'>{event.name}</h3>
              <span className='events-admin-type-badge'>{event.eventType}</span>
            </div>
          </Card.Header>
          <Card.Body>
            {event.title && (
              <Row>
                <Col xs={12} md={12} lg={12}>
                  <div className='events-admin-title'>{event.title}</div>
                </Col>
              </Row>
            )}
            {event.description && (
              <Row>
                <Col xs={12} md={12} lg={12}>
                  <div className='events-admin-description' dangerouslySetInnerHTML={{ __html: event.description }}></div>
                </Col>
              </Row>
            )}
            {event.subdescription && (
              <Row>
                <Col xs={12} md={12} lg={12}>
                  <div className='events-admin-subdescription' dangerouslySetInnerHTML={{ __html: event.subdescription }}></div>
                </Col>
              </Row>
            )}

            <div className='events-admin-timers'>
              <span className='events-admin-timer events-admin-timer--green'>{event.green || '0:00'}</span>
              <span className='events-admin-timer events-admin-timer--amber'>{event.amber || '0:00'}</span>
              <span className='events-admin-timer events-admin-timer--red'>{event.red || '0:00'}</span>
              <span className='events-admin-timer events-admin-timer--total'>{event.total || '0:00'}</span>
            </div>
          </Card.Body>
          <Card.Footer className='events-admin-card-footer'>
            {canEdit &&
              <Row>
                <Col xs={12} className="d-flex gap-2 events-admin-actions">
                  <EditCard
                    event={event}
                    getEvents={getEvents}
                    showEditButton={true}
                    onEdit={() => setIsEditing(true)}
                  />
                  {isWebmaster && (
                    <DeleteCard
                      event={event}
                      getEvents={getEvents}
                      showDeleteButton={true}
                      onDelete={() => getEvents()} // Refresh events after deletion
                    />
                  )}
                </Col>
              </Row>
            }
          </Card.Footer>
        </Card>
      )}
    </Col>
  )
}